import React from "react";
import ReactPaginate from "react-paginate";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { useGlobalState } from "context/GlobalStateContext";

type PaginationPropsType = {
  pagesNumber: number;
  page: number;
  setPage: (value: number) => void;
  onChange?: (currentPage: number) => void;
};

function Pagination({ pagesNumber, page, setPage, onChange }: PaginationPropsType) {
  const { direction } = useGlobalState();

  const handlePageChange = (selected: { selected: number }) => {
    const currentPage = selected.selected + 1;
    setPage(currentPage);
    onChange?.(currentPage);
  };

  const totalPages = Math.ceil(pagesNumber);
  const isLastPage = page >= totalPages;

  return (
    <ReactPaginate
      className="flex flex-row max-md:justify-center items-center space-x-4 "
      breakLabel="..."
      pageRangeDisplayed={2}
      marginPagesDisplayed={1}
      pageCount={pagesNumber}
      forcePage={page - 1}
      previousLabel={
        <div
          className={`border border-backgroundGrey rounded-full drop-shadow-sm shadow-backgroundGrey p-2 
          ${direction === "ltr" ? "rotate-180" : ""}`}
        >
          <FaChevronRight
            size={16}
            className={`${page === 1 ? "text-gray-400" : "text-[#233377]"}`}
          />
        </div>
      }
      nextLabel={
        <div
          className={`border border-backgroundGrey rounded-full drop-shadow-sm shadow-backgroundGrey p-2 
          ${direction === "ltr" ? "rotate-180" : ""}`}
        >
          <FaChevronLeft
            size={16}
            className={`${isLastPage ? "text-gray-400" : "text-[#233377]"}`}
          />
        </div>
      }
      renderOnZeroPageCount={null}
      activeClassName="text-yellow"
      pageClassName="text-blue font-medium text-xl leading-6"
      onPageChange={handlePageChange}
    />
  );
}

export default Pagination;
